import { Form, FormInstance, Select, Typography } from "antd";
import Arrowdown from "../../../common/images/png/ArrowDown.png";
import { ReactComponent as CheckSelectIcon } from "../../../common/images/svg/CheckSelect.svg";
import { ReactComponent as PlusDisabledIcon } from "../../../common/images/svg/PlusDisabled.svg";
import { ReactComponent as PlusGradientIcon } from "../../../common/images/svg/PlusGradient.svg";
import { ReactComponent as ArrowIcon } from "../../../common/images/svg/SuffixSelectIcon.svg";

const { Option } = Select;

interface ISelectWalletProps {
  isTablet: boolean;
  form: FormInstance<any>;
  listWallet: any[];
  walletSelected: any;
  setWalletSelected: React.Dispatch<any>;
  paramsWallet: {
    start: number;
    end: number;
  };
  setParamsWallet: React.Dispatch<
    React.SetStateAction<{
      start: number;
      end: number;
    }>
  >;
  setOpenAddWallet: React.Dispatch<React.SetStateAction<boolean>>;
  loading?: boolean;
}

const SelectWallet = (props: ISelectWalletProps) => {
  const {
    isTablet,
    form,
    listWallet,
    setWalletSelected,
    walletSelected,
    paramsWallet,
    setParamsWallet,
    setOpenAddWallet,
    loading = true,
  } = props;

  return (
    <div>
      <div className="input-recipient-wallet">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: isTablet ? 10 : 12,
            width: "100%",
          }}
        >
          <Form.Item
            style={{ width: "100%" }}
            label="Beneficiary Wallet Address"
            name="beneficiary_wallet_address"
            rules={[{ required: true, message: "This field is required" }]}
          >
            <Select
              showSearch
              disabled={
                !form?.getFieldValue("beneficiary") || !listWallet.length
              }
              className="select-recipient"
              popupClassName="select-beneficiary"
              placeholder="Choose a wallet address"
              optionLabelProp="label"
              suffixIcon={<ArrowIcon />}
              onChange={(id) => {
                const selected = listWallet?.find(
                  (item: any) => item.id === id
                );
                setWalletSelected(selected);
              }}
              filterOption={(input, option: any) => {
                const wallet = listWallet.find((w) => w.id === option.value);
                return (
                  wallet?.name?.toLowerCase().includes(input.toLowerCase()) ||
                  wallet?.address?.includes(input.toLowerCase())
                );
              }}
            >
              {Array.isArray(listWallet) &&
                listWallet.map((item: any) => (
                  <Option
                    key={item.id}
                    value={item.id}
                    label={
                      <span className="ant-select-custom-value-sendmoney">
                        {item.address}
                      </span>
                    }
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <span className="ant-select-custom-value-sendmoney">
                        {item.address}
                      </span>
                      <span style={{ fontWeight: 400, fontSize: "12px" }}>
                        {item.name}
                      </span>
                    </div>
                    {walletSelected?.id === item.id && <CheckSelectIcon />}
                  </Option>
                ))}
              {listWallet.length === paramsWallet.end && (
                <Option key="load-more" disabled>
                  <span
                    style={{
                      fontSize: isTablet ? 12 : 14,
                      color: "rgba(29, 171, 241, 1)",
                      fontWeight: 500,
                      cursor: "pointer",
                      height: "66px",
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setParamsWallet((prev) => ({
                        ...prev,
                        end: prev.end + 10,
                      }));
                    }}
                  >
                    Load more <img src={Arrowdown} />
                  </span>
                </Option>
              )}
            </Select>
          </Form.Item>
          {loading || form.getFieldValue("beneficiary") ? null : (
            <>
              <Typography
                style={{
                  fontSize: isTablet ? 10 : 12,
                  fontWeight: 400,
                  color: "#EC3333",
                }}
              >
                {
                  "Please select a beneficiary before choosing a wallet address."
                }
              </Typography>
            </>
          )}
          {!loading &&
            form.getFieldValue("beneficiary") &&
            listWallet.length === 0 ? (
            <>
              <Typography
                style={{
                  fontSize: isTablet ? 10 : 12,
                  fontWeight: 400,
                  color: "#EC3333",
                }}
              >
                {
                  "No wallet address found for the selected currency. Click 'Add' to set one up"
                }
              </Typography>
            </>
          ) : null}
        </div>
        <div
          className={`button-add-new-recipient ${form.getFieldValue("beneficiary")
            ? ""
            : "button-add-new-recipient-disabled"
            }`}
          onClick={() => {
            if (form.getFieldValue("beneficiary")) setOpenAddWallet(true);
          }}
        >
          {form.getFieldValue("beneficiary") ? (
            <PlusGradientIcon />
          ) : (
            <PlusDisabledIcon />
          )}
        </div>
      </div>
      {walletSelected ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 4,
            marginTop: 8,
          }}
        >
          <Typography
            style={{
              fontSize: isTablet ? 12 : 14,
              fontWeight: 500,
              color: "white",
            }}
          >
            Currency: {walletSelected?.assetConfigGroup?.symbol}
          </Typography>
          <Typography
            style={{
              fontSize: isTablet ? 12 : 14,
              fontWeight: 500,
              color: "white",
            }}
          >
            Network: {walletSelected?.network?.name}
          </Typography>
        </div>
      ) : null}
    </div>
  );
};

export default SelectWallet;
